var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gb-l-token"},[_c('b',[_vm._v(_vm._s(_vm.$t('downloads.yourToken')))]),_c('span',{staticClass:"gb-l-token-text"},[_vm._v(" "+_vm._s(_vm.token == null ? 'Loading token...' : _vm.token)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }